import { render, staticRenderFns } from "./SLPrevValuesDictionaryEditor.vue?vue&type=template&id=5b567e33&scoped=true"
import script from "./SLPrevValuesDictionaryEditor.vue?vue&type=script&lang=js"
export * from "./SLPrevValuesDictionaryEditor.vue?vue&type=script&lang=js"
import style0 from "./SLPrevValuesDictionaryEditor.vue?vue&type=style&index=0&id=5b567e33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b567e33",
  null
  
)

export default component.exports